import { useState } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { PlugConnected20Regular } from '@fluentui/react-icons';

type ConnectorIconProps = {
  iconUri?: string;
  brandColor?: string;
  size?: number;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: tokens.borderRadiusSmall,
    flexShrink: 0,
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  fallbackIcon: {
    color: tokens.colorNeutralForeground1,
  },
});

export const ConnectorIcon = ({ iconUri, brandColor, size = 24 }: ConnectorIconProps) => {
  const styles = useStyles();
  const [hasError, setHasError] = useState(false);

  const showFallback = !iconUri || hasError;

  return (
    <div
      className={styles.container}
      style={{
        width: size,
        height: size,
        backgroundColor: brandColor ?? 'transparent',
      }}
    >
      {showFallback ? (
        <PlugConnected20Regular className={styles.fallbackIcon} />
      ) : (
        <img
          src={iconUri}
          alt=""
          className={styles.image}
          onError={() => setHasError(true)}
        />
      )}
    </div>
  );
};
